import rest from './rest'
import rotas from '../services/rotas'

const lista = () => {
	let lojas = []
	try{
	  const retorno = rest.get(rotas.lojas)
	  retorno.then(ret => {
		//console.log(ret)
		if ((ret.success) && (ret.lista !== '')){
		  lojas = ret.lista
		  sessionStorage.setItem('filial_id', lojas[0].filial_id)
		  sessionStorage.setItem('loja', lojas[0].fantasia)
		}
	  })
	  return (lojas)
	}catch(err){
	  return ('')
	}
}

const centralLoja = () => {
  if (sessionStorage.getItem('filial_id')) {
    let filial = {filial_id: sessionStorage.getItem('filial_id'), loja: sessionStorage.getItem('loja')}
    // console.log(filial)
    return filial
  }

  return {filial_id:'', filial:'Selecione a loja'}
}

const setCentralLoja = (filial_id, loja) => {
  sessionStorage.setItem('filial_id', filial_id)
  sessionStorage.setItem('loja', loja)
  return true
}

export default { centralLoja, setCentralLoja, lista}
